import { Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';

export const SETTINGS_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'medications',
    pathMatch: 'full'
  },
  {
    path: 'medications',
    loadComponent: () =>
      import('./medications/medications.component').then(m => m.MedicationsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'financial-codes',
    loadComponent: () =>
      import('./financial-codes/financial-codes.component').then(m => m.FinancialCodesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'setup-codes',
    loadComponent: () =>
      import('./setup-codes/setup-codes.component').then(m => m.SetupCodesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'booking-items',
    loadComponent: () =>
      import('./booking-items/booking-item.component').then(m => m.BookingItemComponent),
    canActivate: [AuthGuard],
  }
];
